module.exports = __webpack_public_path__ + "img/partner-way.44e2ee8d.svg";